var map = {
	"./000.png": "./src/assets/picture/tarotCards/000.png",
	"./001.png": "./src/assets/picture/tarotCards/001.png",
	"./002.png": "./src/assets/picture/tarotCards/002.png",
	"./003.png": "./src/assets/picture/tarotCards/003.png",
	"./004.png": "./src/assets/picture/tarotCards/004.png",
	"./005.png": "./src/assets/picture/tarotCards/005.png",
	"./006.png": "./src/assets/picture/tarotCards/006.png",
	"./007.png": "./src/assets/picture/tarotCards/007.png",
	"./008.png": "./src/assets/picture/tarotCards/008.png",
	"./009.png": "./src/assets/picture/tarotCards/009.png",
	"./010.png": "./src/assets/picture/tarotCards/010.png",
	"./011.png": "./src/assets/picture/tarotCards/011.png",
	"./012.png": "./src/assets/picture/tarotCards/012.png",
	"./013.png": "./src/assets/picture/tarotCards/013.png",
	"./014.png": "./src/assets/picture/tarotCards/014.png",
	"./015.png": "./src/assets/picture/tarotCards/015.png",
	"./016.png": "./src/assets/picture/tarotCards/016.png",
	"./017.png": "./src/assets/picture/tarotCards/017.png",
	"./018.png": "./src/assets/picture/tarotCards/018.png",
	"./019.png": "./src/assets/picture/tarotCards/019.png",
	"./020.png": "./src/assets/picture/tarotCards/020.png",
	"./021.png": "./src/assets/picture/tarotCards/021.png",
	"./022.png": "./src/assets/picture/tarotCards/022.png",
	"./023.png": "./src/assets/picture/tarotCards/023.png",
	"./024.png": "./src/assets/picture/tarotCards/024.png",
	"./025.png": "./src/assets/picture/tarotCards/025.png",
	"./026.png": "./src/assets/picture/tarotCards/026.png",
	"./027.png": "./src/assets/picture/tarotCards/027.png",
	"./028.png": "./src/assets/picture/tarotCards/028.png",
	"./029.png": "./src/assets/picture/tarotCards/029.png",
	"./030.png": "./src/assets/picture/tarotCards/030.png",
	"./031.png": "./src/assets/picture/tarotCards/031.png",
	"./032.png": "./src/assets/picture/tarotCards/032.png",
	"./033.png": "./src/assets/picture/tarotCards/033.png",
	"./034.png": "./src/assets/picture/tarotCards/034.png",
	"./035.png": "./src/assets/picture/tarotCards/035.png",
	"./036.png": "./src/assets/picture/tarotCards/036.png",
	"./037.png": "./src/assets/picture/tarotCards/037.png",
	"./038.png": "./src/assets/picture/tarotCards/038.png",
	"./039.png": "./src/assets/picture/tarotCards/039.png",
	"./040.png": "./src/assets/picture/tarotCards/040.png",
	"./041.png": "./src/assets/picture/tarotCards/041.png",
	"./042.png": "./src/assets/picture/tarotCards/042.png",
	"./043.png": "./src/assets/picture/tarotCards/043.png",
	"./044.png": "./src/assets/picture/tarotCards/044.png",
	"./045.png": "./src/assets/picture/tarotCards/045.png",
	"./046.png": "./src/assets/picture/tarotCards/046.png",
	"./047.png": "./src/assets/picture/tarotCards/047.png",
	"./048.png": "./src/assets/picture/tarotCards/048.png",
	"./049.png": "./src/assets/picture/tarotCards/049.png",
	"./050.png": "./src/assets/picture/tarotCards/050.png",
	"./051.png": "./src/assets/picture/tarotCards/051.png",
	"./052.png": "./src/assets/picture/tarotCards/052.png",
	"./053.png": "./src/assets/picture/tarotCards/053.png",
	"./054.png": "./src/assets/picture/tarotCards/054.png",
	"./055.png": "./src/assets/picture/tarotCards/055.png",
	"./056.png": "./src/assets/picture/tarotCards/056.png",
	"./057.png": "./src/assets/picture/tarotCards/057.png",
	"./058.png": "./src/assets/picture/tarotCards/058.png",
	"./059.png": "./src/assets/picture/tarotCards/059.png",
	"./060.png": "./src/assets/picture/tarotCards/060.png",
	"./061.png": "./src/assets/picture/tarotCards/061.png",
	"./062.png": "./src/assets/picture/tarotCards/062.png",
	"./063.png": "./src/assets/picture/tarotCards/063.png",
	"./064.png": "./src/assets/picture/tarotCards/064.png",
	"./065.png": "./src/assets/picture/tarotCards/065.png",
	"./066.png": "./src/assets/picture/tarotCards/066.png",
	"./067.png": "./src/assets/picture/tarotCards/067.png",
	"./068.png": "./src/assets/picture/tarotCards/068.png",
	"./069.png": "./src/assets/picture/tarotCards/069.png",
	"./070.png": "./src/assets/picture/tarotCards/070.png",
	"./071.png": "./src/assets/picture/tarotCards/071.png",
	"./072.png": "./src/assets/picture/tarotCards/072.png",
	"./073.png": "./src/assets/picture/tarotCards/073.png",
	"./074.png": "./src/assets/picture/tarotCards/074.png",
	"./075.png": "./src/assets/picture/tarotCards/075.png",
	"./076.png": "./src/assets/picture/tarotCards/076.png",
	"./077.png": "./src/assets/picture/tarotCards/077.png",
	"./078.png": "./src/assets/picture/tarotCards/078.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/picture/tarotCards sync \\.png$";